module.exports = __webpack_public_path__ + "img/about_icon_3.56bba98b.png";